<template>
  <v-container>
    <Title title="Learner Details"></Title>

    <v-row>
      <v-col lg="12" class="pb-2">
        <h2 style="display: inline-block">Pending Learner Request</h2>
        <v-btn
          tile
          v-if="!this.$route.query.id && this.$store.state.role != 'centre'"
          style="float: right"
          color="#6490f1"
          dark
          class="mb-2 ml-3"
          @click="onFinalizeRequest('approved')"
        >
          <v-icon size="20" class="mr-1">mdi-check</v-icon>Approve
        </v-btn>
        <v-btn
          tile
          v-if="!this.$route.query.id && this.$store.state.role != 'centre'"
          style="float: right"
          color="error"
          dark
          class="mb-2"
          @click="onFinalizeRequest('rejected')"
        >
          <v-icon size="20" class="mr-1">mdi-close</v-icon>Reject
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="12">
        <h3>Learner Details</h3>
        <LearnerSummary class="mb-12" />
        <h3>Centre Details</h3>
        <CentreSummary class="mb-12" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CentreSummary from "../components/CentreSummary";
import LearnerSummary from "../components/LearnerSummary";
import Title from "../components/Title";

export default {
  mounted: function () {},
  components: {
    CentreSummary,
    LearnerSummary,
    Title,
  },
  data: function () {
    return {};
  },
  methods: {
    onFinalizeRequest: function (status) {
      if (status.toLowerCase() == "approved") {
        const confirmApprove = window.confirm(`Is the invoice risen?`);
        if (!confirmApprove) {
          return;
        }
      }

      const data = {
        centreId: this.$route.query.centreId,
        learnerId: this.$route.query.learnerId,
        learnerCode: this.$route.query.code,
        status: status,
      };

      fetch(`${process.env.VUE_APP_ROOT_API}/centres/pending?type=learner`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          this.$router.push({
            name: "Dashboard",
            params: { message: data.message },
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
</style>

